import { render, staticRenderFns } from "./padlet_card.vue?vue&type=template&id=858f66dc&"
import script from "./padlet_card.vue?vue&type=script&lang=js&"
export * from "./padlet_card.vue?vue&type=script&lang=js&"
import style0 from "./padlet_card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports